@if (items.length) {
  <div class="ui-list-view__list ui-list-view__list--{{ listFormat }}">
    <ng-content></ng-content>
  </div>
} @else {
  @if (placeHolderText) {
    <p> {{ placeHolderText }} </p>
  }
}


